import {TileCacheLayer} from '../TileCacheLayer.js';
import Library from '../Library.js';

export class RadarLayer extends TileCacheLayer {

    constructor( map, settings = {} ){
        if( settings.name == undefined ) settings['name'] = "radar";
        if( settings.type == undefined ) settings['type'] = "rad_win";
        if( settings.opacity == undefined ) settings['opacity'] = 0.75;
        settings["dynamic_time"] = true;
        super( map, settings );
        this.setLabel();
    }

    refresh(){
        this.setLabel();
        super.refresh();
    }

    async setLabel(){
        let elem = document.getElementById('label_radar');
        if( elem == null ) return;
        let url = new URL( this.map.server + "/cgi-bin/image/radar.php" );
        url.searchParams.set( "type", this.settings['type']);
        url.searchParams.set( "output", "label" );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        let response = await fetch( url.toString());
        let label = await response.text();
        elem.innerText = label;
    }

    setType(val){
        this.settings['type'] = val;
        this.refresh();
    }

    updateTime(){
        this.refresh();
    }
}
